import { Icons } from '@Components/icon/Icon';
import { OnboardingFormFields } from '@Types/index.ts';
import {  ReactElement } from 'react';
type EnumToInterface<T extends object> = { [K in keyof T]: string };

export type FormFieldErrors = EnumToInterface<typeof OnboardingFormFields>;

export interface IErrorSlice {
  errorSlice: {
    formFieldErrors: FormFieldErrors;
    errorModal: {
      error: string;
      modalProps?: IErrorModalProps;
    };
    setFormFieldError: (field: keyof FormFieldErrors, error: string) => void;
    setErrorModal: (data: { error: string; modalProps?: IErrorModalProps }) => void;
    resetFormFieldErrors: () => void;
  };
}

export enum ErrorModalTypes {
  GENERAL = 'general',
  CUSTOM = 'custom',
}
export interface IErrorModalProps {
  title?: string;
  content?: string;
  icon?: Icons;
  buttonText?: string;
  button2Text?: string;
  type: ErrorModalTypes | undefined;
  onSubmit?: () => void;
  onCancel?: () => void;
  cmp?: () => ReactElement;
}
